module.exports = __webpack_public_path__ + "media/Loops Drums.12ba737e.wav";